//定义搜索相关的全局变量

export default {
    //允许组件有自己的命名空间，以和其他做区分
    namespaced: true,
    state: {
        //定义搜索使用的默认搜索体，供全局使用
        query: { offset: 0, limit: 50, type: 0, keyword1: "", keyword2: [] },
    },
    mutations: {
        //暂时没有

    },
}